import BpkGraphicPromo, {
  TEXT_ALIGN,
} from '@skyscanner-internal/backpack-web/bpk-component-graphic-promotion';
import { redirect } from 'saddlebag-browser';

import withErrorBoundary from '../ErrorBoundary/WithErrorBoundary';
import FooterBlurb from '../common/FooterBlurb';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type { MultiImageBannerProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/MultiImageBannerProps';

import STYLES from './MultiImageBanner.module.scss';

const handleClick = (content: string, url: string) => {
  redirect(url);
};

const MultiImageBanner = (props: MultiImageBannerProps) => {
  const {
    backgroundImage: {
      backgroundImageDesktop,
      backgroundImageMobile,
      backgroundImageTablet,
    },
    buttonText,
    disclaimer,
    heading,
    invertVertically = true,
    renderAsLink = false,
    subheading,
    url,
    useOverlay = false,
  } = props;

  const style = backgroundImageTablet
    ? {
        '--background-image-desktop': `url(${backgroundImageDesktop})`,
        '--background-image-mobile': `url(${backgroundImageMobile})`,
        '--background-image-tablet': `url(${backgroundImageTablet})`,
      }
    : {
        '--background-image-desktop': `url(${backgroundImageDesktop})`,
        '--background-image-mobile': `url(${backgroundImageMobile})`,
      };

  const { buildMBDParam, rawComponentName } = useMBDContext();

  return (
    <div
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      <BpkGraphicPromo
        className={`${STYLES.MultiImageBanner} ${
          useOverlay ? STYLES.MultiImageBannerWithFilter : ''
        } ${!invertVertically ? STYLES.MultiImageBannerBottomText : ''}`}
        buttonText={buttonText}
        headline={heading}
        subheading={subheading}
        onClick={() => handleClick(buttonText, url)}
        style={style}
        textAlign={TEXT_ALIGN.start}
        invertVertically={invertVertically}
        href={renderAsLink ? url : undefined}
      />

      {disclaimer && (
        <div className={STYLES.MultiImageBanner__disclaimer}>
          <FooterBlurb disclaimerCopy={disclaimer} />
        </div>
      )}
    </div>
  );
};

const MultiImageBannerBannerWithErrorBoundary = withErrorBoundary(
  MultiImageBanner,
  'multi-image-banner-component',
);

export default MultiImageBannerBannerWithErrorBoundary;
